import UploadButton from "./UploadButton";
import Button from "../Button";
import { useState } from "react";

const InvoiceTemplate = () => {

    const [field1, setField1] = useState('');
  const [field2, setField2] = useState('');
  const [field3, setField3] = useState('');
  const [field4, setField4] = useState('');
//   const [field5, setField5] = useState('');

    const handleSubmit = (event) => {
        // Handle form submission logic
        event.preventDefault();
        console.log('Form submitted');
      };

        // Function to reset the form
  const handleReset = () => {
    setField1('');
    setField2('');
    setField3('');
    setField4('');
    // setField5('');
   
  };

  return (
    <>
    <form action="" className='create-customer-form-expanded flex flex-col gap-10 ml-4' onSubmit={handleSubmit}> 
        <section className='flex gap-10'>
            <div className='flex flex-col invoice-template-input'>
                <label htmlFor="">Company name</label>
                <input type="text" value={field1} placeholder='The Laundry Basket, Sedona' className='mt-2' onChange={(e) => setField1(e.target.value)}/>
            </div>
            <div className='flex flex-col invoice-template-input'>
                <label htmlFor="">Company email</label>
                <input type="text" value={field2} placeholder='support@laundrybasket.com' className='mt-2' onChange={(e) => setField2(e.target.value)}/>
            </div>
        </section>

        <section className='flex gap-10'>
            <div className='flex flex-col invoice-template-input'>
                <label htmlFor="">Company phone number</label>
                <input type="text" value={field3} placeholder='+123456789' className='mt-2' onChange={(e) => setField3(e.target.value)}/>
            </div>
            <div className='flex flex-col mt-6'>
                <label htmlFor="">Company logo</label>
                <UploadButton  onChange={(e) => setField4(e.target.value)}/>
                <p className="mt-4 logo-upload-instruction">*Upload JPG or PNG. Max file size 5MB.</p>

            </div>
        </section>

        <section className=''>
            <div className='flex flex-col invoice-template-input'>
                <label htmlFor="">Company address</label>
                <textarea type="text" value={field4} placeholder='7901 Chapel Close, Harvey Rd. Arizona, USA.' className='mt-2' onChange={(e) => setField4(e.target.value)}/>
            </div>
        </section>
        <section className='mt-10 flex gap-10'>
            <div className=''>
                <Button>Save</Button>
            </div>
            <Button style={{background: 'none', color: '#434C5A', fontWeight: '400'}} onClick={handleReset}>Reset changes</Button>
            
            
        </section>
    </form>
    </>
  )
}

export default InvoiceTemplate